module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Shield-user-90954e1cafa57dd154360d0f7da82996.svg";